import { HealthCertificateDto } from "./healthCertificate.dto";
import { HealthCertificateTypeDto, HealthCertificateTypeSettingDto } from "./healthCertificateType.dto";

/**
 * Interface representing the health certificate add form.
 */
export interface EditHealthCertificateFormDto{
    id?: number | null;
    driverId?: number | null;
    type: HealthCertificateTypeDto | null;
    typeSetting: HealthCertificateTypeSettingDto | null;
    issued: Date | null;
    validTo: Date | null;
    certificateFile: File | null;
    certificateUrl: string | null;
}

export const mapToEditHealthCertificateFormDto = (formData: HealthCertificateDto): EditHealthCertificateFormDto => {
    return {
        id: formData.id,
        driverId: formData.driverId,
        type: formData.type,
        typeSetting: formData.typeSetting ?? null,
        issued: formData.issued,
        validTo: formData.validTo,
        certificateFile: formData.photoFile,
        certificateUrl: formData.photoUrl
    };
}